module.exports = __webpack_public_path__ + "img/5.66b7650f.png";